import { IEventType } from "../types/IEventType";
import { IServiceEvent } from "../types/IServiceEvent";
import { Api } from "./api";

export const GetServiceStatus = async (
    serviceId: string
): Promise<IServiceEvent[]> => {
    const api = await Api();
    const apiResponse = await api
        .get(`dashboard-ui/services/${serviceId}/status`)
        .then((result) => {
            const data = result.data.data as IServiceEvent[];
            if (data) {
                for (let index = 0; index < data.length; index++) {
                    const event = data[index];
                    const time = event.eventId.split(":")[1];
                    event.timestamp = new Date(parseInt(time));
                }
            }
            return data;
        });

    return apiResponse;
};

export const GetSubServiceStatus = async (
    serviceId: string,
    subServiceId: string
): Promise<IServiceEvent[]> => {
    const api = await Api();
    const apiResponse = await api
        .get(`dashboard-ui/services/${serviceId}/status/${subServiceId}`)
        .then((result) => {
            const data = result.data.data as IServiceEvent[];
            if (data) {
                for (let index = 0; index < data.length; index++) {
                    const event = data[index];
                    const time = event.eventId.split(":")[1];
                    event.timestamp = new Date(parseInt(time));
                }
            }
            return data;
        });

    return apiResponse;
};

export const GetServiceErrors = (events: IServiceEvent[]): IServiceEvent[] => {
    const errors = [] as IServiceEvent[];
    events.forEach((event) => {
        if (event.type == IEventType.ERROR) {
            errors.push(event);
        }
    });
    return errors;
};
